class DetailsModal extends HTMLElement {
	constructor() {
		super();
		this.detailsContainer = this.querySelector('details');
		this.summaryToggle = this.querySelector('summary');

		if (!this.detailsContainer || !this.summaryToggle) return;

		this.detailsContainer.addEventListener('keyup', (event) => {
			if (event.code && event.code.toUpperCase() === 'ESCAPE') {
				this.close();
			}
		});

		this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

		// Bind all close buttons
		const closeButtons = this.querySelectorAll('.modal__close-button, .bibinono-search__close-btn, [data-search-close]');
		closeButtons.forEach((btn) => {
			btn.addEventListener('click', (event) => {
				event.preventDefault();
				event.stopPropagation();
				this.close(true);
			});
		});

		this.summaryToggle.setAttribute('role', 'button');
	}

	isOpen() {
		return this.detailsContainer ? this.detailsContainer.hasAttribute('open') : false;
	}

	onSummaryClick(event) {
		event.preventDefault();
		event.stopPropagation();
		this.isOpen() ? this.close() : this.open();
	}

	onBodyClick(event) {
		if (!this.isOpen()) return;

		// If click was on or inside the summary toggle, onSummaryClick handles it
		if (this.summaryToggle && (this.summaryToggle === event.target || this.summaryToggle.contains(event.target))) {
			return;
		}

		// If click was inside the floating search card, keep it open
		const innerCard = this.querySelector('.search-modal__content');
		if (innerCard && innerCard.contains(event.target)) {
			return;
		}

		// Otherwise (clicked the dimmed backdrop or outside), close search
		this.close(false);
	}

	open() {
		if (!this.detailsContainer) return;
		this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
		this.detailsContainer.setAttribute('open', '');
		document.body.classList.add('overflow-hidden', 'search-modal-open');
		document.documentElement.classList.add('search-modal-open');

		const header = this.closest('.header') || document.querySelector('.header');
		if (header) header.classList.add('header--search-open');
		const headerWrapper = this.closest('.header-wrapper') || document.querySelector('.header-wrapper');
		if (headerWrapper) headerWrapper.classList.add('header-wrapper--search-open');

		// Attach body click listener with pointer event support
		setTimeout(() => {
			document.addEventListener('click', this.onBodyClickEvent);
		}, 50);

		// Auto-focus search input with selection
		const searchInput = this.detailsContainer.querySelector('input[type="search"], input:not([type="hidden"])');
		if (searchInput) {
			setTimeout(() => {
				searchInput.focus();
				if (searchInput.value && typeof searchInput.setSelectionRange === 'function') {
					searchInput.setSelectionRange(0, searchInput.value.length);
				}
			}, 100);
		}

		if (typeof trapFocus === 'function') {
			trapFocus(
				this.detailsContainer.querySelector('[tabindex="-1"]') || this.detailsContainer,
				searchInput
			);
		}
	}

	close(focusToggle = true) {
		if (!this.detailsContainer) return;
		if (typeof removeTrapFocus === 'function') {
			removeTrapFocus(focusToggle ? this.summaryToggle : null);
		}
		this.detailsContainer.removeAttribute('open');

		const header = this.closest('.header') || document.querySelector('.header');
		if (header) header.classList.remove('header--search-open');
		const headerWrapper = this.closest('.header-wrapper') || document.querySelector('.header-wrapper');
		if (headerWrapper) headerWrapper.classList.remove('header-wrapper--search-open');

		if (this.onBodyClickEvent) {
			document.removeEventListener('click', this.onBodyClickEvent);
		}
		document.body.classList.remove('overflow-hidden', 'search-modal-open');
		document.documentElement.classList.remove('search-modal-open');
	}
}

if (!customElements.get('details-modal')) {
	customElements.define('details-modal', DetailsModal);
}
